import { memo, useCallback } from 'react';

import { WorkspaceAgentComposerArchivedSessionMessage } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/composer/WorkspaceAgentComposerArchivedSessionMessage';
import { useUnarchiveWorkspaceAgentTask } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useUnarchiveWorkspaceAgentTask';
import { usePrivateWorkspaceAgentPanelSession } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';

export const WORKSPACE_AGENT_COMPOSER_ARCHIVED_SESSION_MESSAGE = 'This thread has been archived.';
export const WORKSPACE_AGENT_COMPOSER_ARCHIVED_SESSION_CTA_LABEL = 'Unarchive';

export type PrivateWorkspaceAgentPanelComposerArchivedSessionMessageProps = {
  headingId: string;
};

export const PrivateWorkspaceAgentPanelComposerArchivedSessionMessage = memo(
  ({ headingId }: PrivateWorkspaceAgentPanelComposerArchivedSessionMessageProps) => {
    const { sessionId } = usePrivateWorkspaceAgentPanelSession();
    const { isUnarchivingSession, unarchiveTask } = useUnarchiveWorkspaceAgentTask();

    const handleUnarchiveClick = useCallback(() => {
      if (sessionId === null) {
        return;
      }

      void unarchiveTask(sessionId);
    }, [sessionId, unarchiveTask]);

    return (
      <WorkspaceAgentComposerArchivedSessionMessage
        headingId={headingId}
        isUnarchivePending={sessionId !== null && isUnarchivingSession(sessionId)}
        message={WORKSPACE_AGENT_COMPOSER_ARCHIVED_SESSION_MESSAGE}
        onUnarchiveClick={handleUnarchiveClick}
        unarchiveCtaLabel={WORKSPACE_AGENT_COMPOSER_ARCHIVED_SESSION_CTA_LABEL}
      />
    );
  },
);

PrivateWorkspaceAgentPanelComposerArchivedSessionMessage.displayName =
  'PrivateWorkspaceAgentPanelComposerArchivedSessionMessage';
